import { getClusters } from '../services';
export const fetchClusters = () => getClusters().then(response => formatResponse(response?.data));
const formatResponse = (response) => {
    return response?.data.map((cluster, index) => ({
        label: cluster,
        value: index,
    }));
};
